import { type ReactNode, useId, useMemo } from 'react';

import type { TEmbedElement } from '@shared/dream-components';
import { EmbedElement } from '@shared/dream-components';
import { ClientOnly } from 'remix-utils/client-only';

interface Props {
  node: TEmbedElement;
  children: ReactNode | ReactNode[];
}
const Embed = ({ node, children }: Props) => {
  const reactId = useId();
  const { htmlOriginal, id: nodeId, timestamp } = node.attrs;

  // Only use node's UUID if it has a timestamp (meaning it was saved to database)
  // This prevents breaking existing sites that have nodes with UUIDs but no database records
  // Grandfathered content (no timestamp) will use React ID and render legacy srcdoc iframes
  const id = nodeId && timestamp ? nodeId : reactId;

  // If the embed element has the no-iframe comment, we render it
  // with ClientOnly to avoid hydration issues
  const noIframe = htmlOriginal?.match(/<!--\s*beehiiv:no-iframe\s*-->/);

  const memoizedEmbed = useMemo(() => {
    return (
      <EmbedElement id={id} element={node}>
        {children}
      </EmbedElement>
    );
  }, [id, node, children]);

  if (noIframe) {
    return <ClientOnly>{() => memoizedEmbed}</ClientOnly>;
  }
  return memoizedEmbed;
};

export default Embed;
